import request from '../../utils/request'
import prefix from '../prefix'
import auth from '../auth'

/***
 * 新增用户链接
 * @param data
 * @returns {AxiosPromise}
 */
export const sysBannerList = data => {
  return request({
    url: prefix + auth + '/sys-banner/list',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/sysBanner/sysBanner.js